import { RowData } from '@tanstack/react-table';
import { useNaviTableContext } from '../../context/NaviTableContext';
import { NaviTableVariants } from '../../interfaces';
import styles from './NaviTableBody.module.scss';
import NaviTableBodyRowWrapper from './NaviTableBodyRowWrapper';
import cx from 'classnames';

const NaviTableBody = <TData extends RowData>() => {
  const { variant = NaviTableVariants.DEFAULT } = useNaviTableContext<TData>();
  return (
    <div
      className={cx({
        [styles.naviTableBody]: variant === NaviTableVariants.DEFAULT,
        [styles.naviTableBodyCard]: variant === NaviTableVariants.CARDS
      })}
    >
      <NaviTableBodyRowWrapper />
    </div>
  );
};

export default NaviTableBody;
